export const pt = {
  navbar: {
    home: "Home",
    about: "Sobre",
    media: "Multimédia", 
    gallery: "Galeria",
    repertoire: "Repertório",
    contact: "Contacto",
    youtube: "Canal YouTube"
  },
  hero: {
    title: "João Xavier",
    subtitle: " Pianista",
    discoverMore: "Descubra Mais",
    getInTouch: "Entre em Contacto"
  },

  about: {
    title: "Sobre mim",
    biography: [
      "Um dos pianistas portugueses mais promissores da sua geração, João Xavier tem cativado plateias em Portugal, Espanha, Bélgica, Itália e Rússia. Apresentou-se em prestigiadas salas, como a Sala Suggia da Casa da Música, no Porto, o Grande Auditório da Fundação Calouste Gulbenkian, em Lisboa, os Teatros del Canal, em Madrid, a Grande Sala do Conservatório Real de Bruxelas e a Grande Sala do Conservatório Tchaikovsky de Moscovo.",
      "Vencedor de diversos concursos, João Xavier recebeu distinções como o 1º prémio no Concurso do Festival Estoril Lisboa (2021), o 1º lugar no 'Prémio Jovens Músicos' (2011), e o 1º prémio nos Concursos de Piano da Póvoa de Varzim, Florinda Santos e Santa Cecília, no Porto. Recebeu ainda o 3º prémio no Concurso Internacional de Piano de Jaén, em Espanha (2014).",
      "Nascido em Lousada, iniciou os estudos musicais no Conservatório do Vale do Sousa, sob a orientação da professora Luísa Ferreira. Prosseguiu a sua formação com Pedro Burmester na Escola Superior de Música e Artes do Espetáculo (ESMAE), no Porto. Trabalhou também com a pianista Tania Achot e, na Scuola di Musica di Fiesole, em Florença, com Eliso Virsaladze, com quem mais tarde prosseguiu os seus estudos no Conservatório Estatal Tchaikovsky de Moscovo, tendo-se graduado em 2020 com distinção. Em 2023 obteve o grau de mestrado com distinção no Koninklijk Conservatorium de Bruxelas, sob orientação de Aleksandar Madžar.",
      "Apresentou-se a solo, com orquestra e em recitais de música de câmara em diversos festivais, tais como o Festival Internacional de Música da Póvoa de Varzim, o Festival Cistermusica, em Alcobaça, ou, mais recentemente, o Festival Midis-Minimes, em Bruxelas.",
      "Enquanto solista, colaborou com várias orquestras em Portugal, Espanha e na Rússia, nomeadamente com a Orquestra da Fundação Calouste Gulbenkian; a Orquestra Sinfónica do Porto – Casa da Música, a Orquestra Cidade de Granada, a Orquestra Metropolitana de Lisboa, a Orquestra Sinfónica de Estudantes do Conservatório de Moscovo ou a Orquestra Sinfónica Portuguesa, e com maestros como Pedro Neves, Nikolay Lalov, Günter Neuhold, Anatoly Levin, Stefan Blunier e Vasily Sinaisky."
    ]
  },
  media: {
    title: "Multimédia"
  },
  gallery: {
    title: "Galeria",
    nextImage: "Próxima imagem",
    previousImage: "Imagem anterior"
  },
  repertoire: {
    title: "Repertório para piano e orquestra",
    list: [
      {
        composer: "W. A. Mozart",
        pieces: [
          'Concerto para Piano n.º9, em mi bemol maior, K. 271, “Jeunehomme”',
          'Concerto para Piano n.º12, em lá maior, K. 414',
          'Concerto para Piano n.º15, em si bemol maior, K.450',
          'Concerto para Piano n.º17, em sol maior, K.453',
          'Concerto para Piano n.º18, em si bemol maior, K. 456',
          'Concerto para Piano n.º23, em lá maior, K. 488',
          'Concerto para Piano n.º24 em dó menor, K. 491',
          'Concerto para Piano n.º25, em dó maior, K. 503'
        ]
      },
      {
        composer: "L. van Beethoven",
        pieces: [
          'Concerto para Piano n.º1, em dó maior, Op. 15',
          'Concerto para Piano n.º2, em si bemol maior, Op. 19',
          'Concerto para Piano n.º3, em dó menor, Op. 37',
          'Concerto para Piano n.º4 em sol maior, Op. 58',
          'Concerto para Piano n.º5, em mi bemol maior, Op. 73'
        ]
      },
      {
        composer: "F. Chopin",
        pieces: [
          'Concerto para Piano n.º1, em mi menor, Op. 11',
          'Concerto para Piano n.º2, em fá menor, Op. 21'
        ]
      },
      {
        composer: "R. Schumann",
        pieces: [
          'Concerto para Piano em lá menor, Op. 54',
          'Introdução e Allegro appassionato em sol maior, Op. 92'
        ]
      },
      {
        composer: "E. Grieg",
        pieces: [
          'Concerto para Piano em lá menor, Op. 16'
        ]
      },
      {
        composer: "F. Liszt",
        pieces: [
          'Concerto para Piano n.º1, em mi bemol maior',
          'Concerto para Piano n.º2, em lá maior'
        ]
      },
      {
        composer: "J. Brahms",
        pieces: [
          'Concerto para Piano n.º2, em si bemol maior, Op. 83'
        ]
      },
      {
        composer: "P. I. Tchaikovsky",
        pieces: [
          'Concerto para Piano n.º1, em si bemol menor, Op. 23'
        ]
      },
      {
        composer: "S. Rachmaninov",
        pieces: [
          'Concerto para Piano n.º1, em fá sustenido menor, Op. 1',
          'Concerto para Piano n.º2, em dó menor, Op. 18'
        ]
      },
      {
        composer: "S. Prokofiev",
        pieces: [
          'Concerto para Piano n.º3, em dó maior, Op. 26',
          'Concerto para Piano n.º4, em si bemol maior (para a mão esquerda), Op. 53'
        ]
      }
    ]
  },
  contact: {
    title: "Contacto",
    nameLabel: "Nome",
    emailLabel: "Email", 
    messageLabel: "Mensagem",
    submitBtn: "Enviar Mensagem",
    submittingBtn: "A enviar...",
    successMessage: "Mensagem enviada com sucesso!",
    successDescription: "Obrigado pelo contacto. Responderei em breve.",
    errorMessage: "Falha ao enviar mensagem",
    errorDescription: "Por favor, tente novamente ou contacte-me diretamente por email.",
    waitMessage: "Por favor, aguarde",
    waitDescription: "Por favor, aguarde alguns segundos antes de submeter novamente.",
    namePlaceholder: "Nome completo",
    emailPlaceholder: "seuemail@exemplo.com", 
    messagePlaceholder: "Fale-me sobre o seu projeto, evento ou coloque a sua questão..."
  },
  footer: {
    copyright: `© ${new Date().getFullYear()} João Xavier`
  },
  language: {
    english: "EN",
    portuguese: "PT"
  },
  aria: {
    toggleMenu: "Alternar menu",
    scrollIndicator: "Deslizar para baixo",
    languageSwitcher: "Mudar idioma"
  }
};